import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JobRoleCreateRedirectInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (
            request.method === 'POST' &&
            request.url.includes(
              '/api/access-control/client-api/v2/accessgroups/function-groups'
            ) &&
            event.status === 202
          ) {
            console.log("home/company-permissions/user-roles/list")
            this.router.navigate(['home/company-permissions/user-roles/list']);
          }
        }
      })
    );
  }
}
